module.exports = new __parcel__URL__("favicon-512.5e08f951.png").toString();